export default __webpack_public_path__ + "static/Earth_Glossiness-minified-ff8d1e724aa2fa3bf260aa0749d18a51.jpg";